/**
 * toggle-object-tools
 * a button for phones to open the object-tools
 * icon is a wrench/cog
 * it only shows when there are object-tools and is user
 */

/* @ngInject */
export function toggleObjectTools(
  flux,
  User,
  Analytics,
  Menu,
  ObjectTools,
  device
) {
  return {
    link: function($scope, $element) {
      var last;

      // show it when tools are present
      function update() {
        var show = ObjectTools.items.length && device.isPhone();
        if (show !== last) {
          $element.toggleClass("hidden", !show);
        }
        last = show;
      }

      if (User.isUser()) {
        $element.on("click", function(event) {
          $scope.$apply(function() {
            Menu.mouseIsActive(event);
            flux.dispatch("toggleMenu", {
              menu: "tools"
            });
            Analytics.track("mobileToggleObjectTools");
            event.preventDefault();
          });
        });

        update();
        flux.onChanged("ObjectTools", update, $scope);
        flux.onChanged(
          "Menu",
          function(state) {
            var open = state.open && state.menu === "tools";
            $element.attr("aria-pressed", open ? "true" : "false");
            $element.toggleClass("upside-down", open || false);
          },
          $scope
        );
      }
    }
  };
}
